import { render, staticRenderFns } from "./kingdom.vue?vue&type=template&id=92e634e8&scoped=true&"
import script from "./kingdom.vue?vue&type=script&lang=js&"
export * from "./kingdom.vue?vue&type=script&lang=js&"
import style0 from "./kingdom.vue?vue&type=style&index=0&id=92e634e8&lang=scss&scoped=true&"
import style1 from "./kingdom.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e634e8",
  null
  
)

export default component.exports